import React from 'react'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { Skeleton } from '@mui/material'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import Card from '@SonarCX/components/atoms/Card'
import EditDelete from '../EditDelete'

import { selectTeams } from '@SonarCX/slices/teamsSlice'
import useStyles from './styles'

type TeamsCardsProps = {
  openModal: (data: APITeam) => () => void
}

const TeamsCards: React.FC<TeamsCardsProps> = ({ openModal }) => {
  const { loaded, teams } = useAppSelector(selectTeams)

  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {!loaded && (
        <Card style={{ padding: '0' }}>
          <Skeleton variant='rounded' style={{ height: '100px' }} />
        </Card>
      )}

      {loaded && teams.length === 0 && (
        <Card>
          <div className={classes.noData}>No teams</div>
        </Card>
      )}

      {teams.map(team => (
        <Card key={team.id}>
          <div className={classes.dataRow}>
            <div className={classes.name}>{team.name}</div>

            <div className={classes.edit}>
              <EditDelete open={openModal} data={team} />
            </div>
          </div>

          <div className={classes.dataRow}>
            <div>Description</div>

            <div>{team.desc}</div>
          </div>

          <div className={classes.dataRow}>
            <div>Members</div>

            <div>{team.members.length}</div>
          </div>
        </Card>
      ))}
    </CardColumn>
  )
}

export default TeamsCards
